import React from "react";
import Link from "next/link";
import Image from "next/image";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Keyboard, Scrollbar, Navigation, Pagination } from 'swiper/modules';
const AppProjektDetailsComponent = ({ headerTitle, headerSlag, swiperItems, headerDescription, altGoogleStore, altAppStore, googleLink, appleLink }) => {
    return (
        <>
            <div className="appItem">
                <div className="appprojectItem">
                    <div className="boxItem">
                        <div className="boxitemArticle">
                            <div className='boxitemContainer'>
                                <div className="boxitemImagesBackground">

                                    <Swiper
                                        slidesPerView={1}
                                        centeredSlides={false}
                                        slidesPerGroupSkip={1}
                                        grabCursor={true}
                                        keyboard={{
                                            enabled: true,
                                        }}

                                        scrollbar={true}
                                        navigation={true}
                                        pagination={{
                                            clickable: true,
                                        }}
                                        modules={[Keyboard, Scrollbar, Navigation, Pagination]}
                                        className="simplifyswiper"
                                    >
                                        {swiperItems}
                                    </Swiper>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="appDescriptionContainer">

                    <div className="appDescriptionCategoryContainer">
                        <div className="slagitem">{headerSlag}</div>
                    </div>
                    <h5 className="appTitle">{headerTitle}</h5>
                    <div className="appDescription">{headerDescription}</div>


                    <div className="row">
                        <div className="col-lg-6 col-sm-6 appStoreLinks tx-center">
                            {googleLink ? (
                                <Link href={`${googleLink}`}>
                                    <Image
                                        src="/images/app-development/googleplay.svg"
                                        height={300}
                                        width={300}
                                        className='imageproduct'
                                        alt={altGoogleStore}
                                    />
                                </Link>)
                                :
                                (<Image
                                    src="/images/app-development/googleplay.svg"
                                    height={300}
                                    width={300}
                                    className='imageproduct notAvaible'
                                    alt={altGoogleStore}
                                />)}

                        </div>
                        <div className="col-lg-6 col-sm-6 appStoreLinks tx-center">
                            {appleLink ? (
                                <Link href={`${appleLink}`}>
                                    <Image
                                        src="/images/app-development/appstore.svg"
                                        height={300}
                                        width={300}
                                        className='imageproduct'
                                        alt={altAppStore}
                                    />
                                </Link>)
                                :
                                (<Image
                                    src="/images/app-development/appstore.svg"
                                    height={300}
                                    width={300}
                                    className='imageproduct notAvaible'
                                    alt={altAppStore}
                                />)}
                        </div>
                    </div>
                </div>



            </div>
        </>
    );
};

export default AppProjektDetailsComponent;
